import { Src_Inst } from './src_inst';
import { Obj_Db_Property } from '../datapoint/obj_db_property';
import { DxMp_Fwd_Lnk } from './dxmp_fwd_lnk.';
import { DObj } from './dobj';
import { RepConn } from '../datapoint/repconn';
import { CommonEnums } from '../../common.enums';
import { DObjsUtil } from '../../utils/dobjs.util';
import { DxMp_Fwd_LnksUtil } from '../../utils/dxmp_fwd_lnks.util';
import { Obj_Db_PropertiesUtil } from '../../utils/obj_db_properties.util';

export class SourceConnect {
    src_Inst: Src_Inst;
    source_Properties: Array<Obj_Db_Property>;
    nativeDbTyp_Id: number;
    change_Ind: string;
    error_Cd: string;
    error_Msg: string;
    ref_Id: number;
    ref_Cd: string
    fldr_Id: number;
    imageUrl: string
    dObjs: Array<DObj>;
    repConn: RepConn;
    srcConnectLnks: Array<DxMp_Fwd_Lnk>;
    filter_Properties: Array<Obj_Db_Property>;

    constructor() {
        this.setDefaults()
    }

    setDefaults() {
        this.src_Inst = new Src_Inst();
        this.dObjs = new Array<DObj>();
        this.srcConnectLnks = new Array<DxMp_Fwd_Lnk>();
        this.source_Properties = new Array<Obj_Db_Property>();
        this.nativeDbTyp_Id = CommonEnums.defaults.DEFAULT_INT_VAL;
        this.repConn = new RepConn();
        this.change_Ind = CommonEnums.change_Ind.NO_CHANGE;
        this.error_Cd = CommonEnums.defaults.SUCCESS_CODE;
        this.error_Msg = CommonEnums.defaults.SUCCESS_MSG;
        this.ref_Id = CommonEnums.defaults.LONG_VAL;
        this.ref_Cd = CommonEnums.defaults.STRING_EMPTY;
        this.fldr_Id = CommonEnums.defaults.LONG_VAL;
        this.imageUrl = CommonEnums.defaults.STRING_EMPTY;
        this.filter_Properties = new Array<Obj_Db_Property>();
    }

    static parse(sourceConnectTmp: SourceConnect): SourceConnect {
        let sourceConnect: SourceConnect = new SourceConnect();
        sourceConnect.copyFrom(sourceConnectTmp);
        return sourceConnect;
    }

    copy(): SourceConnect {
        let sourceConnectTmp: SourceConnect = new SourceConnect()

        sourceConnectTmp.src_Inst = this.src_Inst.copy();
        sourceConnectTmp.dObjs = DObjsUtil.getInstance().copy(this.dObjs);
        sourceConnectTmp.srcConnectLnks = DxMp_Fwd_LnksUtil.getInstance().copy(this.srcConnectLnks);
        sourceConnectTmp.source_Properties = Obj_Db_PropertiesUtil.getInstance().copy(this.source_Properties);
        sourceConnectTmp.filter_Properties = Obj_Db_PropertiesUtil.getInstance().copy(this.filter_Properties)
        sourceConnectTmp.nativeDbTyp_Id = this.nativeDbTyp_Id;
        sourceConnectTmp.repConn = this.repConn;
        sourceConnectTmp.change_Ind = this.change_Ind;
        sourceConnectTmp.error_Cd = this.error_Cd;
        sourceConnectTmp.error_Msg = this.error_Msg;
        sourceConnectTmp.ref_Id = this.ref_Id;
        sourceConnectTmp.ref_Cd = this.ref_Cd;
        sourceConnectTmp.fldr_Id = this.fldr_Id;
        sourceConnectTmp.imageUrl = this.imageUrl;

        return sourceConnectTmp;
    }

    copyFrom(sourceConnectTmp: SourceConnect): void {
        this.src_Inst.copyFrom(sourceConnectTmp.src_Inst);
        DObjsUtil.getInstance().copyFrom( this.dObjs, sourceConnectTmp.dObjs);
        DxMp_Fwd_LnksUtil.getInstance().copyFrom(this.srcConnectLnks, sourceConnectTmp.srcConnectLnks);
        let obj_Db_PropertiesUtil: Obj_Db_PropertiesUtil = Obj_Db_PropertiesUtil.getInstance();
        obj_Db_PropertiesUtil.copyFrom(this.source_Properties, sourceConnectTmp.source_Properties);
        obj_Db_PropertiesUtil.copyFrom(this.filter_Properties, sourceConnectTmp.filter_Properties);
        if (this.source_Properties.length > 0) {
            obj_Db_PropertiesUtil.setShowOn(this.source_Properties, true, this.source_Properties[0].propertyType_Cd);
            obj_Db_PropertiesUtil.setShowOn(this.source_Properties, false, this.source_Properties[0].propertyType_Cd);
        }
        this.nativeDbTyp_Id = sourceConnectTmp.nativeDbTyp_Id;
        this.repConn = sourceConnectTmp.repConn;
        this.change_Ind = sourceConnectTmp.change_Ind;
        this.error_Cd = sourceConnectTmp.error_Cd;
        this.error_Msg = sourceConnectTmp.error_Msg;
        this.ref_Id = sourceConnectTmp.ref_Id;
        this.ref_Cd = sourceConnectTmp.ref_Cd;
        this.fldr_Id = sourceConnectTmp.fldr_Id;
        this.imageUrl = sourceConnectTmp.imageUrl;
    }

    compare(sourceConnectTmp: SourceConnect): string {
        let sourceConnectString: string = this.toString(false);
        let sourceConnectTmpString: string = sourceConnectTmp.toString(false);

        if (sourceConnectString != sourceConnectTmpString) {
            return sourceConnectString + ', ' + sourceConnectTmpString;
        }

        return '';
    }

    toString(isNotCompare: boolean = true): string {
        let obj_Db_PropertiesUtil: Obj_Db_PropertiesUtil = Obj_Db_PropertiesUtil.getInstance();
        let dObjsUtil: DObjsUtil = DObjsUtil.getInstance();
        let dxMp_Fwd_LnksUtil: DxMp_Fwd_LnksUtil = DxMp_Fwd_LnksUtil.getInstance();
        return "Source Connect [ src_Inst=" + this.src_Inst.toString() +
            ", dObjs=" + dObjsUtil.toString(this.dObjs) +
            ", srcConnectLnks=" + dxMp_Fwd_LnksUtil.toString(this.srcConnectLnks) +
            ", source_Properties=" + obj_Db_PropertiesUtil.toString(this.source_Properties, isNotCompare) +
            ", filter_Properties=" + obj_Db_PropertiesUtil.toString(this.filter_Properties) +
            ", nativeDbTyp_Id=" + this.nativeDbTyp_Id +
            ", repConn=" + this.repConn +
            ", error_Cd=" + this.error_Cd +
            ",ref_Cd =" + this.ref_Cd +
            ",fldr_Id =" + this.fldr_Id +
            ",imageUrl =" + this.imageUrl + "]";

        // if (isNotCompare) {
        //     str += "change_Ind=" + this.change_Ind ;
        // }

        // str += ']';

        // return str;
    }

}